module.exports = __webpack_public_path__ + "img/eye.70be4a9d.svg";